import React, { Component } from 'react';

export default class Icon_Carousel extends Component {
	constructor(props) {
		super(props);
		this.state = {

		}
	}

	componentDidMount() {
		var elmnt = document.getElementById(this.props.id + '_' + 'selected');
		if (elmnt != null) elmnt.scrollIntoView({ behavior: "smooth", inline: "center" });
	}

	handleSelectIcon = (key) => {
		this.props.handleSelectIcon(key);
	}

	render() {
		let style = {
			width: this.props.width - 40,
			// Change carousel height to prevent it from scrolling up/down
			height: 80,
			marginLeft: 'auto',
			marginRight: 'auto',
			overflow: 'auto'
		};

		let carousel_total_width = this.props.icon_list.length * 70;
		if (carousel_total_width < this.props.width - 40) carousel_total_width = this.props.width - 40;

		let carousel_internal_style = {
			height: 60,
			width: carousel_total_width,
		}

		let img_style = {
			width: 20,
			padding: 10,
			cursor: 'pointer'
		}

		style = Object.assign(style, this.props.style);

		return (
			<div id={this.props.id} style={style}>
				<div style={carousel_internal_style}>
					{this.props.icon_list.map((icon_details) => {
						let icon_id = icon_details.key
						if (icon_details.is_selected) {
							icon_id = 'selected';
						}
						return (
							<div id={this.props.id + '_' + icon_id} style={{ cursor: 'pointer', width: 60, height: 60, backgroundColor: icon_details.is_selected ? window.app.state.colours.appBlue : 'white', display: 'inline-block', marginLeft: 10 }}
								onClick={() => this.handleSelectIcon(icon_details.key)}>
								<img src={icon_details.icon} style={{ width: 50, paddingTop: 5 }} />
							</div>
						)
					})}
				</div>
			</div>
		)
	}
}


